import { externalMapSearchUrl } from "@/lib/maps/externalLinks";
import { buildTelUrl } from "@/lib/driver/driverTelLinks";

export function buildServiceTechMapsUrl(locationAddress: string | null | undefined): string | null {
  const query = locationAddress?.trim() || "";
  return query ? externalMapSearchUrl(query) : null;
}

export { buildTelUrl };
